import httpClient from 'agentHTTPClient';
import routes from 'agentRoutes';

const fetchCountryList = async () => {
  const { data } = await httpClient.get(routes.api.country());
  const formatedOptions = data.map(option => ({ label: option.name, value: option.code }));

  return Promise.resolve(formatedOptions);
};

const findCorrespondenceCountryLabel = (countryList, value) => {
  if (!countryList) return null;

  const selectedOption = countryList.filter(item => value === item.value)[0];
  if (selectedOption) {
    return selectedOption.label;
  }

  return null;
};

export { fetchCountryList, findCorrespondenceCountryLabel };
